<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-6 col-lg-6">
                    <stats-card title="Active Promos"
                        type="gradient-green"
                        :sub-title="String(activePromos)"
                        icon="fas fa-check"
                        class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-6 col-lg-6">
                    <stats-card title="Inactive Promos"
                        type="gradient-red"
                        :sub-title="String(inactivePromos)"
                        icon="fas fa-stop-circle"
                        class="mb-4 mb-xl-0">
                    </stats-card>

                    <template slot="footer">
                        <br><br>
                    </template>
                </div>
                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Promo Hits"
                        type="gradient-yellow"
                        :sub-title="promoHits"
                        icon="fa fa-chart-line"
                        class="mb-4 mb-xl-0">
                    </stats-card>

                    <template slot="footer">
                        <br><br>
                    </template>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total Sold"
                        type="gradient-blue"
                        :sub-title="totalAmountSold"
                        icon="fas fa-shopping-basket"
                        class="mb-4 mb-xl-0">
                    </stats-card>
                </div> -->
                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total Discounts"
                        type="gradient-red"
                        :sub-title="totalDiscounts"
                        icon="fas fa-percent"
                        class="mb-4 mb-xl-0">
                    </stats-card>

                    <template slot="footer">
                        <br><br>
                    </template>
                </div> -->
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-md-12">
                    <div class="card-body" style="background: #FFFFFF; min-height: 40vh;">
                        <h3>Select Promo Type
                            <base-dropdown v-if="accessRights.includes('V') || accessRights.includes('W')" class="nav-link pr-0 float-right" position="right">
                                <div class="media align-items-center" slot="title">
                                    <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                </div>
                                <template>
                                    <div class="dropdown-header noti-title">
                                    <h6 class="text-overflow m-0">ACTIONS</h6>
                                    </div>
                                    <div class="dropdown-item" v-if="accessRights.includes('G')" @click.prevent="showActionDrawer('configure')">
                                        <i class="ni ni-settings-gear-65"></i>
                                        <span>Configuration</span>
                                    </div>
                                    <div class="dropdown-item" @click.prevent="showActionDrawer('configurationhist')">
                                        <i class="fa fa-history"></i>
                                        <span>Configuration History</span>
                                    </div>
                                </template>
                            </base-dropdown>
                        </h3>
                        <div class="table-responsive pt-2" v-if="accessRights.includes('V') || accessRights.includes('W') || accessRights.includes('A')">
                            <VueTabulator ref="tabulator" v-model="acctPromos" :options="options" @cell-click="redirectPromoLink"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <a-drawer title="" :width="480" placement="right" @close="closeDrawer" :visible="drawerVisible">
            <div v-if="profileAction == 'configure'">
              <h6 class="heading-small text-muted mb-4">Customize Promos</h6>
               <ul class="list-group list-group-flush" style="width: 100%">
                   <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                       <div class="row">
                           <div class="col-md-6">
                               AVAILABLE PROMOS
                           </div>
                           <div class="col-md-6">
                              <a-checkbox @change="onCheckAllField" :checked="checkedFields.length == tabledata.length" class="float-right"/>
                           </div>
                        </div>
                   </li>
                   <li class="list-group-item" style="font-size: 14px" v-for="promo in tabledata" v-bind:key="promo['promo_type_id']">
                    <div class="row">
                      <div class="col-md-6">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{promo['sdescription']}}
                      </div>
                      <div class="col-md-6">
                        <a-checkbox @change="onCheckField(promo['promo_type_id'])" :checked="checkedFields.includes(promo['promo_type_id'])" class="float-right" />
                      </div>
                    </div>
                  </li>
                  <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="accessRights.includes('W')" type="button" class="btn btn-primary float-right" @click.prevent="saveConfig">Save</button>
                </div>
               </ul>
            </div>
         </a-drawer>

         <a-drawer title="" :width="1200" placement="right" @close="closeDrawer" :visible="configHistoryVisible">
            <div v-if="profileAction == 'configurationhist'">
                <document-configuration-history @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey"></document-configuration-history>
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import axios from "axios";
    import { mapState, mapActions } from 'vuex'
    import secureStorage from '../../controllers/secureStorage';
    import HTTPRequest from '../../controllers/httpRequest.js'
    import { compareData } from '../../utilities';
    import moment from 'moment';
    import DocumentConfigurationHistory from '../Documents/DocumentConfigurationHistory.vue'

    let printIcon = function(cell, formatterParams){
        return "<i class='fas fa-angle-right'></i>";
    };

    export default {
        data() {
            return {
                componentKey: 0,
                configHistoryVisible: false,
                acctPromos: [],
                promoOptions: [],
                activePromoOptions: [],
                drawerVisible: false,
                profileAction: null,
                checkedFields: ["name"],
                fields: ['__checkbox', "id", "name", '__slot:actions'],
                activePromos:  0,
                activePromos1:  0,
                activePromos2:  0,
                activePromos3:  0,
                activePromos4:  0,
                activePromos5:  0,
                activePromos6:  0,
                activePromos7:  0,
                inactivePromos:  0,
                inactivePromos1:  0,
                inactivePromos2:  0,
                inactivePromos3:  0,
                inactivePromos4:  0,
                inactivePromos5:  0,
                inactivePromos6:  0,
                inactivePromos7:  0,
                promoHits: "0",
                totalAmountSold: "0",
                totalDiscounts: "0",
                tabledata: [],
                options: {
                    height:"100%",
                    columns: [
                        {
                            title:'PROMO TYPE',
                            field:'sdescription',
                            width:"15%",
                            headerSort: false,
                            formatter:"textarea"
                        }, 
                        {
                            title:'DESCRIPTION',
                            field:'description',
                            width:"50%",
                            headerSort: false,
                            formatter:"textarea"
                        },                      
                        {
                            title: 'ACTIVE / INACTIVE',
                            field: 'active_inactive',
                            width: "15%",
                            headerSort: false
                        },
                        {
                            formatter: printIcon, 
                            field: 'action',
                            width: "20%", 
                            headerSort: false
                        }
                    ]
                },
                accessRights: [],
                activeModules: [],
                moduleId: 0,
                initSettings: [],
            }
        },
        mounted: async function () {
            this.activePromoOptions = [];
            var promoConfig = await HTTPRequest.getRequest(this.endPoint + "system_settings?module_name=promoConfig" , null)
            
             //[ERK] Add user access right to edit the list of promo schemes  
             var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=MDM-004', null, null)
             this.activeModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)
        
             if( this.activeModules.length > 0 ){
                 var profile = _.snakeCase(this.activeModules[0].name)
                 this.setCurrentProfile(_.pluralize(profile), this.activeModules[0].id);
             } else {
                 this.setCurrentProfile(null, null);
                 this.formKey++
             } 
                  

            // Create system settings for new account
            if(promoConfig.data.length == 0) {
                var createParams = {
                    system_setting: {
                    module_name: "promoConfig",
                    settings_json: JSON.stringify([]),
                    },
                };

                await HTTPRequest.postRequest(
                    this.endPoint + "/system_settings",
                    null,
                    createParams
                );

                var promoConfig = await HTTPRequest.getRequest(this.endPoint + "system_settings?module_name=promoConfig" , null)
                this.activePromoOptions = [];
                this.checkedFields = [];
            } else {
                this.activePromoOptions = promoConfig.data[0].settings_json;
                this.checkedFields = promoConfig.data[0].settings_json;
            }
            console.log(promoConfig)
            console.log(this.activePromoOptions)
            this.initSettings = promoConfig.data[0].settings_json.toString().replace('[', '').replace(']', '').split(',').sort(function(a, b){return a - b})
            this.getStats('A')
            this.getStats('I')
            secureStorage.setItem("documentTypeId", -1);
        },
        components: {
            DocumentConfigurationHistory
        },
        computed: {
            ...mapState(['endPoint'])
        },
        methods: {
            moment,
            refreshPage(){
                this.onClose()
                this.$refs.vuetable.refresh()
                this.successMessage = "Successful Operation"
                this.errorMessage = null
            },
            redirectPromoLink(e, cell){
                if(cell._cell.column.field == "action"){
                    this.$router.push('/advanced_promotions/' + cell.getRow().getData().promo_type_id + '|' + this.moduleId);
                }
            },

            async setCurrentProfile(profile, id) {
                this.moduleId = id
                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
                if (_.isEmpty(accessRightsRequest.access_rights) == false){
                    this.accessRights = accessRightsRequest.access_rights[id]
                }else {
                    this.accessRights = []
                }
            },

            async saveConfig() {
                var promoConfig = await HTTPRequest.getRequest(this.endPoint + "system_settings?module_name=promoConfig" , null)

                this.checkedFields.toString().replace("[", "")
                this.checkedFields.toString().replace("", "]") 
                this.checkedFields.toString().replace("\"name\"", "")
                this.checkedFields.toString().replace("\"", "")
                this.checkedFields.toString().replace("\/", "")

                var updateParams = {
                    system_setting: {
                    module_name: "promoConfig",
                    settings_json: JSON.stringify(this.checkedFields),
                    },
                };
                await HTTPRequest.putRequest(
                    this.endPoint + "/system_settings/" + promoConfig.data[0].id,
                    null,
                    updateParams
                );

                this.$notification["success"]({
                message: "Successful",
                description:
                    "Promo configuration has been saved. Please refresh page for changes to take effect.",
                });
                // const updatedSettings = this.checkedFields.sort(function(a, b){return a - b})
                let updatedSettings = this.checkedFields.toString().replace('[', '').replace(']', '').replace(NaN, '').split(',').sort(function(a, b){return a - b})
                updatedSettings = Array.from(updatedSettings, item => typeof item === 'undefined' ? 0 : item).filter(Number);
                let initSettings = Array.from(this.initSettings, item => typeof item === 'undefined' ? 0 : item).filter(Number);
            
                let activate = updatedSettings.filter(x => !initSettings.includes(x));
                if(activate.length > 0) {
                    activate.forEach((item) => {
                        var configHistoryPayload = {
                            config: 'Promotion',
                            config_type: this.tabledata[item - 1].sdescription,
                            config_from: 'Disable',
                            config_to: 'Enable',
                            config_at: moment(new Date()),
                            config_by: secureStorage.getItem("userName"),
                            config_account: secureStorage.getItem("accountId"),
                            document_type: -1
                              }
                          // Save config changes
                            HTTPRequest.postRequest(this.endPoint + 'document_configuration_histories/', null, configHistoryPayload)
                    });
                }
                let deactivate = initSettings.filter(x => !updatedSettings.includes(x));
                if(deactivate.length > 0) {
                     deactivate.forEach((item) => {
                        var configHistoryPayload = {
                            config: 'Promotion',
                            config_type: this.tabledata[item - 1].sdescription,
                            config_from: 'Enable',
                            config_to: 'Disable',
                            config_at: moment(new Date()),
                            config_by: secureStorage.getItem("userName"),
                            config_account: secureStorage.getItem("accountId"),
                            document_type: -1
                              }
                          // Save config changes
                          HTTPRequest.postRequest(this.endPoint + 'document_configuration_histories/', null, configHistoryPayload)
                    });
                }
                
                this.initSettings = updatedSettings
                this.closeDrawer();
                // window.location.reload()
            },
            async showActionDrawer(action) {
                this.profileAction = action
                if (action == "configure"){
                    this.configVisible = true
                    this.drawerVisible = true
                } else if(action == "configurationhist") {
                    this.configHistoryVisible = true
                } else {
                    this.drawerVisible = true
                }
            },
            closeDrawer(){
                this.drawerVisible = false
                this.configHistoryVisible = false
                this.visible = false
            },
            onCheckField(fieldName) {
                this.checkedFields = this.checkedFields.toString().replace('[', '').replace(']', '')
                this.checkedFields = this.checkedFields.split(',').map(function(item) {
                    return parseInt(item, 10);
                }); 
    
                if(this.checkedFields.includes(fieldName)){
                    var indexValue = this.fields.indexOf(fieldName)
                    if (indexValue > -1) this.fields.splice(indexValue, 1)
                    var indexValue2 = this.checkedFields.indexOf(fieldName)
                    if (indexValue2 > -1) this.checkedFields.splice(indexValue2, 1)
                }else{
                    this.fields.pop()
                    this.fields.push(fieldName)
                    this.fields.push("__slot:actions")
                    this.checkedFields.push(fieldName)
                }
    
                
            },
            onCheckAllField() {
                this.promoOptions = [];
                for (let i = 0; i < this.tabledata.length; i++) {
                    this.promoOptions.push(this.tabledata[i].promo_type_id)
                }

                if(this.checkedFields.length == this.promoOptions.length){
                    this.checkedFields = []
                    this.fields = ['__checkbox', "id", "name", '__slot:actions']
                } else {
                    this.checkedFields = this.promoOptions.slice()
                    this.fields = ['__checkbox', "id", "name"]
                    this.fields = this.fields.concat(this.promoOptions)
                    this.fields.push("__slot:actions")
                }
            },

            async getStats(stat){
                var getStats = await axios({
                method: 'get',
                headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
                url: this.endPoint + 'promotions?status='+stat
                });

                if(stat === 'A'){
                    // this.activePromos = getStats.data.total;
                    this.activePromos = 0;
                    var tData = getStats.data
                    for (var i in tData.data) {
                        if(this.activePromoOptions.includes(tData.data[i].promo_type) == true)
                            this.activePromos++
                        if(tData.data[i].promo_type === '1')
                            this.activePromos1 = this.activePromos1 + 1
                        else if(tData.data[i].promo_type === '2') 
                            this.activePromos2 = this.activePromos2 + 1
                        else if(tData.data[i].promo_type === '3') 
                            this.activePromos3 = this.activePromos3 + 1
                        else if(tData.data[i].promo_type === '4') 
                            this.activePromos4 = this.activePromos4 + 1
                        else if(tData.data[i].promo_type === '5') 
                            this.activePromos5 = this.activePromos5 + 1
                        else if(tData.data[i].promo_type === '6') 
                            this.activePromos6 = this.activePromos6 + 1
                        else 
                            this.activePromos7 = this.activePromos7 + 1
                    } 
                } else {
                    // this.inactivePromos = getStats.data.total;
                    this.inactivePromos = 0;
                    var tData = getStats.data
                    for (var i in tData.data) {
                        if(this.activePromoOptions.includes(tData.data[i].promo_type) == true)
                            this.inactivePromos++
                        if(tData.data[i].promo_type === '1')
                            this.inactivePromos1 = this.inactivePromos1 + 1
                        else if(tData.data[i].promo_type === '2') 
                            this.inactivePromos2 = this.inactivePromos2 + 1
                        else if(tData.data[i].promo_type === '3') 
                            this.inactivePromos3 = this.inactivePromos3 + 1
                        else if(tData.data[i].promo_type === '4') 
                            this.inactivePromos4 = this.inactivePromos4 + 1
                        else if(tData.data[i].promo_type === '5') 
                            this.inactivePromos5 = this.inactivePromos5 + 1
                        else if(tData.data[i].promo_type === '6') 
                            this.activePromos6 = this.activePromos6 + 1
                        else 
                            this.activePromos7 = this.activePromos7 + 1
                    } 
                }
                    
                this.tabledata = [
                    {promo_type_id:1, sdescription:"Simple Discount",  description:"Simple Discount\nNew Price, Amount Discount", active_inactive: this.activePromos1 + "/" + this.inactivePromos1},
                    {promo_type_id:2, sdescription:"Multilevel Discount", description:"Multilevel Discount\nDirect Discount, Quantity Required, Amount Required", active_inactive: this.activePromos2 + "/" + this.inactivePromos2},
                    {promo_type_id:3, sdescription:"Buy X Take Y", description:"Buy X Take Y\nBuy X Take Y for: Percent Discount, Amount Discount, New Price ...", active_inactive: this.activePromos3 + "/" + this.inactivePromos3},
                    {promo_type_id:4, sdescription:"Pricing Schemes", description:"Pricing Schemes\nTiered Pricing, Volume Pricing, Bundle Pricing", active_inactive: this.activePromos4 + "/" + this.inactivePromos4},
                    {promo_type_id:5, sdescription:"Coupon", description:"Coupon\nStandard Coupon, Quantity Required for Coupon, Amount Required ...", active_inactive: this.activePromos5 + "/" + this.inactivePromos5},
                    {promo_type_id:6, sdescription:"Conditional", description:"Conditional", promo_hits: 0, active_inactive: this.activePromos6 + "/" + this.inactivePromos6},
                    {promo_type_id:7, sdescription:"Group Discount", description:"Discounts are computed at the end of the transaction before\npayment is made", promo_hits: 0, active_inactive: this.activePromos7 + "/" + this.inactivePromos7} ]
                
                this.acctPromos = []
                for (let i = 0; i < this.tabledata.length; i++) {
        
                    if(this.activePromoOptions.includes(this.tabledata[i].promo_type_id) == true){
                        this.acctPromos.push({
                            promo_type_id: this.tabledata[i].promo_type_id,
                            sdescription: this.tabledata[i].sdescription,
                            description: this.tabledata[i].description,
                            active_inactive: this.tabledata[i].active_inactive,
                        })
                    }
                    
                }
            },
        }
    }
</script>

<style lang='scss'>
    @import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";
    .tabulator-group-toggle{
        display: none;
    }
    .tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title {
        text-align: left;
    }
</style>